<template>
  <div class="package-name-background py-1 px-2"><p class="mb-0">{{ item.label }} </p></div>
</template>

<script>
export default {
  name: 'PackageItemInfo',
  props: ['item']
}
</script>
